import userReducer, {
  selectAccessToken,
  selectMyFundraisers,
  selectUserRoles,
  USER_REDUCER_KEY,
} from './userReducer';
import {
  handleLogout,
  resetUserReducer,
  setAccessToken,
  loadMyFundraisers,
} from './userActions';

export {
  USER_REDUCER_KEY,
  setAccessToken,
  resetUserReducer,
  selectAccessToken,
  selectMyFundraisers,
  selectUserRoles,
  loadMyFundraisers,
  handleLogout,
};

export default userReducer;
